import React, { useEffect, useState } from "react";
import { Modal } from "react-materialize";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import TableLoader from "../../../loader/TableLoader";
import {
  auctionTypeStyle,
  convertTo12HourFormat,
  handleDateSetUp,
  NoItemsLeftInTable,
} from "../../../../helpers/helpers";
import { getTodayPublicTable } from "../../../../redux/action/landing";
import LoginComponent from "../../../auth/components/LoginComponent";
import Pagination from "../../pagination/Pagination";
import { useNavigate } from "react-router-dom";

function TodayPublicTable({ auctionFilter }) {
  const totalNumberRow = 30;
  const navigate = useNavigate();
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });
  const [currentPage, setCurrentPage] = useState(0);
  const [todayData, setTodayData] = useState([]);
  const dispatch = useDispatch();
  const { todayPublicData, loadings } = useSelector((pre) => pre.publicTable);

  useEffect(() => {
    dispatch(getTodayPublicTable(auctionFilter, setTodayData));
  }, [dispatch, auctionFilter]);

  useEffect(() => {
    setTodayData(todayPublicData);
  }, [todayPublicData]);

  return (
    <>
      {loadings ? (
        <div className="valign-wrapper justify-center cover white">
          <TableLoader
            headerData={[
              "Auction ID",
              "Description",
              "Auction Type",
              "Date/Timings",
              "Actions",
            ]}
          />
        </div>
      ) : (
        <>
          {" "}
          <div className={`${!isTablet && "table-container-style"}`}>
            <table
              className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
                } `}
            >
              <thead className="grey lighten-4 ">
                <tr className="centered">
                  <th>Auction ID</th>
                  <th>Description</th>
                  <th>Auction Type</th>
                  <th>Date/Time</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {todayData
                  ?.slice(currentPage, currentPage + 15)
                  ?.map((items, index) => (
                    <tr key={items?._id}>
                      <td>{items?.auctionId}</td>

                      <td style={{ width: !isTablet && "300px" }}>
                        <span
                          className="NoOfline"
                          style={{ WebkitLineClamp: 1 }}
                        >
                          {items.description}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`${items?.auctionType === "reverseAuctionService"
                            ? "auctiontype-reverseService"
                            : items?.auctionType === "reverseAuctionProduct"
                              ? "reverseAuctionProduct"
                              : "auctiontype-forward"
                            }`}
                        >
                          {auctionTypeStyle(items?.auctionType)}{" "}
                        </span>
                      </td>
                      <td style={{ width: !isTablet && "300px" }}>
                        <p>
                          {handleDateSetUp(items?.auctionSchedule?.startDate)}
                          {" , "}
                          {convertTo12HourFormat(
                            items?.auctionSchedule?.startingTime
                          )}{" "}
                          to{" "}
                          {convertTo12HourFormat(
                            items?.auctionSchedule?.endingTime
                          )}
                        </p>
                      </td>
                      <td>
                        <span
                          className="material-icons modal-trigger cercle-purple-text  pointer"
                          href="#modalAuth"
                          onClick={() => { isMobile && navigate("/login") }}
                        >
                          visibility
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {todayData?.length === 0 && <NoItemsLeftInTable />}
          </div>
          <Pagination
            Data={todayData}
            totalNumberRow={totalNumberRow}
            setCurrentPage={setCurrentPage}
          />
        </>
      )}
      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        style={styles.modal}
        className="modelAccount"
        id="modalAuth"
        open={false}
      >
        <div>
          <p
            className="modal-close valign-wrapper mr-1"
            style={{ justifyContent: "end" }}
          >
            <span className="material-icons-outlined">close</span>
          </p>
          <div className="valign-wrapper justify-center">
            <LoginComponent />
          </div>
        </div>
      </Modal>
    </>
  );
}
const styles = {
  modal: {
    width: "530px",
  },
  modalContent: {
    padding: "10px",
  },
};

export default TodayPublicTable;
